import { render, staticRenderFns } from "./EditarUbicacion.vue?vue&type=template&id=34583a13"
import script from "./EditarUbicacion.vue?vue&type=script&lang=js"
export * from "./EditarUbicacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports